var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSauna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 224 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.389 85.4367C190.291 68.539 178.341 54.1254 163.052 44.0189C147.762 33.9123 129.819 28.5666 111.491 28.6578C93.163 28.7489 75.2739 34.2729 60.0855 44.5311C44.8972 54.7892 33.0918 69.3209 26.1623 86.2885",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61679 129.747L6.07786 114.923L3.2066 98.1582C1.98793 91.0426 6.76834 84.2864 13.8839 83.0677V83.0677C20.9995 81.849 27.7558 86.6294 28.9744 93.745L31.8457 110.51L34.6509 128",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.034 128.886L217.573 114.062L220.445 97.2971C221.663 90.1815 216.883 83.4253 209.767 82.2066V82.2066C202.652 80.9879 195.895 85.7683 194.677 92.8839L191.805 109.649L189.067 128.139",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112 130H59M112 130L112.25 265M112 130H165M59 130L72.625 265M59 130H45.75H39.125H35.8125H32.5H19.25H12.625H10.3023C8.07657 130 6.40725 132.036 6.84375 134.219V134.219L7.6875 138.437L9.375 146.875L12.75 163.75M112.25 265H72.625M112.25 265H151.875M72.625 265H38.7386C35.4019 265 32.529 262.645 31.8746 259.373L29.625 248.125L27.9375 239.687L27.0938 235.469M165 130L151.875 265M165 130H191.5H204.75H211.375H214.688V130C216.403 130 217.692 131.567 217.362 133.25L217.172 134.219L216.344 138.437L214.688 146.875L211.375 163.75M151.875 265H185.74C189.087 265 191.965 262.632 192.609 259.348L194.812 248.125L196.469 239.687L197.297 235.469M12.75 163.75L16.125 180.625M12.75 163.75H211.375M16.125 180.625L19.5 197.5L22.875 214.375M16.125 180.625H208.062M22.875 214.375L26.25 231.25L27.0938 235.469M22.875 214.375H201.438M211.375 163.75L208.062 180.625M208.062 180.625L204.75 197.5L201.438 214.375M201.438 214.375L198.125 231.25L197.297 235.469M27.0938 235.469H197.297",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSauna);
export default __webpack_public_path__ + "static/media/sauna.a4f842eb50e959edf2169b45078fa5b2.svg";
export { ForwardRef as ReactComponent };